(ns dre.components.collapsable-panel
  (:require
   [dre.components.icon :refer [icon]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.utils.bem :as utils.bem]
   [reagent.core :as r]))

(def component-name :collapsable-panel)

(defn- be
  [e]
  (utils.bem/be component-name e))

(defn- bem
  [e m]
  (utils.bem/bem component-name e m))

(defn- collapse
  [collapsed?]
  [:div
   {:class (be :collapse)
    :on-click #(swap! collapsed? not)}
   [icoinor-icon 
    (if @collapsed?
      :nav-arrow-down
      :nav-arrow-up)]])

(defn collapsable-panel
  [_]
  (let [collapsed? (r/atom false)]
    (fn [{:keys [title actions content]}]
      [:div
       {:class component-name}
       [:div
        {:class (be :header)}
        [:h4
         {:class (be :title)}
         title]
        [:div
         {:class (be :actions)}
         [actions]]
        [collapse collapsed?]]
       [:div
        {:class (if @collapsed?
                  (bem :content :collapsed)
                  (be :content))}
        [content]]])))
